import { MedicalLeaveGuardianRelation } from '@dreryk/egabinet-ezla-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { ContentExpander, FormController, SecondaryText, Select } from '@dreryk/react-components';

import { commonTranslationKeys, guardianTranslationKeys } from '../../../../../../translations';
import { StyledContentExpanderContent } from '../../../../common/StyledContentExpanderContent';
import { GuardianMedicalLeaveFormController } from '../../../guardianMedicalLeave.types';

import { StyledRelationCodesDescriptions } from './StyledRelationCodesDescriptions';
import { StyledRelationCodeSelect } from './StyledRelationCodeSelect';

type RelationCodeSelectProps = {
   readonly controller: GuardianMedicalLeaveFormController;
};

const RELATION_CODES: MedicalLeaveGuardianRelation[] = ['CHILD', 'NEXT_OF_KIN', 'OTHER'];

const useTriggerLabelExtractor = (currentValue?: MedicalLeaveGuardianRelation): string => {
   const translate = useTranslate();
   return translate(guardianTranslationKeys[`relationCode_${currentValue!}` as const]);
};

export const RelationCodeSelect = (props: RelationCodeSelectProps): JSX.Element => {
   return (
      <StyledRelationCodeSelect>
         <Select<MedicalLeaveGuardianRelation>
            testId={'patientRelationCode'}
            triggerLabelExtractor={useTriggerLabelExtractor}
            label={guardianTranslationKeys.relationCode}
            controller={props.controller.register('relationCode', { required: true })}
         >
            <Select.List items={RELATION_CODES}>
               {(relationCode) => (
                  <Select.Item
                     testId={relationCode}
                     item={relationCode}
                     label={guardianTranslationKeys[`relationCode_${relationCode}`]}
                  />
               )}
            </Select.List>
         </Select>
         <StyledRelationCodesDescriptions>
            <ContentExpander
               expandLabel={commonTranslationKeys.showCodesDescriptions}
               collapseLabel={commonTranslationKeys.hideCodesDescriptions}
               testId='relationCodesDescriptions'
            >
               <StyledContentExpanderContent>
                  {RELATION_CODES.map((code) => (
                     <SecondaryText
                        key={code}
                        text={guardianTranslationKeys[`relationCodeDescription_${code}` as const]}
                        testId={code}
                     />
                  ))}
               </StyledContentExpanderContent>
            </ContentExpander>
         </StyledRelationCodesDescriptions>
         <FormController controller={props.controller.register('relationCode')} />
      </StyledRelationCodeSelect>
   );
};
